import { useMutation, useQueryClient } from "@tanstack/vue-query";

import KiliApi from "@/data/api/kili/kili-api";
import { SecurityMutationKeys } from "@/data/api/kili/security/security-query-keys";

export function useLogoutMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: SecurityMutationKeys.logout(),
    mutationFn: async () => {
      return KiliApi.logout(undefined);
    },
    onSuccess: () => {
      queryClient.resetQueries();
    },
  });
}
